import { useSignedUrl } from './useNotebookQueries';
import { NotebookFile } from './useGetAllFiles';
import { toast } from 'react-toastify';

const useDownloadFile = () => {
  const { mutateAsync: getSignedUrl } = useSignedUrl();

  return async (file: NotebookFile) => {
    if (!file?.fileUrl || String(file.id).startsWith('temp-')) {
      toast.info('File is still uploading');
      return;
    }
    try {
      const url = await getSignedUrl(file?.fileUrl);
      const res = await fetch(url, { headers: {} });
      const blob = await res.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = file.file_name;
      a.click();
      URL.revokeObjectURL(a.href);
    } catch (_) {
      toast.error('Failed to download file');
    }
  };
};
export default useDownloadFile;
